module.exports = __webpack_public_path__ + "static/media/ru.562474ef.svg";